/**
 * Sticky page header.
 *
 * Sits at the top of a page with a title, optional subtitle, and a
 * right-aligned actions slot. The sticky variant applies a translucent
 * backdrop-filter so content scrolling under it stays legible.
 *
 *   <PageHeader
 *     title="Children"
 *     subtitle="423 registered"
 *     actions={<Button>Add child</Button>}
 *     sticky
 *   />
 */
import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import "./PageHeader.css";

export function PageHeader({
    title,
    subtitle,
    actions,
    sticky = false,
    className = "",
    icon: Icon,
}) {
    return (
        <Box
            className={`pt-page-header ${sticky ? "sticky" : ""} ${className}`}
            sx={{
                backdropFilter: sticky ? "blur(8px)" : undefined,
            }}
        >
            <Stack direction="row" alignItems="center" spacing={1.5}>
                {Icon ? (
                    <Box
                        sx={{
                            width: 38,
                            height: 38,
                            borderRadius: 2,
                            bgcolor: "var(--pt-primary)",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        aria-hidden="true"
                    >
                        <Icon size={20} />
                    </Box>
                ) : null}
                <Box>
                    <Typography variant="h4" component="h1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography
                            variant="body2"
                            sx={{ color: "var(--pt-text-secondary)", mt: 0.25 }}
                        >
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Stack>
            {actions ? <Stack direction="row" spacing={1.25} alignItems="center">{actions}</Stack> : null}
        </Box>
    );
}

export default PageHeader;
